export const SERVICE_LINES = ["Debt", "M&A", "Restructuring", "Firm-wide"];
export const AUDIENCE_STREAMS = [
  { value: "owner-managed", label: "Owner-managed" },
  { value: "sponsor-backed", label: "Sponsor-backed" },
  { value: "both", label: "Both" },
];
export const REGIONS = ["UK and Ireland", "Europe", "APAC", "US", "Global"];
export const ROLE_LABELS = { owner: "Owner", member: "Member", viewer: "Viewer" };
export const GUARDRAIL = "Nothing here publishes or sends. An agent drafts; a person acts.";

const TEAM_KEYS = ["strategy", "social", "direct", "creative", "inbound", "quality"];

export function teamKey(team, index = 0) {
  const label = `${team?.section || ""} ${team?.name || ""}`.toLowerCase();
  const found = TEAM_KEYS.find((k) => label.includes(k));
  return found || TEAM_KEYS[index % TEAM_KEYS.length];
}

export function teamColour(team, index = 0) {
  return `var(--team-${teamKey(team, index)})`;
}

export function applyTheme(pref) {
  const dark =
    pref === "dark" || (pref === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
  localStorage.setItem("fcg-theme", pref);
}
